import { Requirements } from './Requirements';


export const ServiceTasks = () => (
  <Requirements
    title="Tasks"
    singular="Task"
    endpoint="service-tasks"
    subtitle="Manage tasks available in Service Hub"
    emptyPrompt="Add a task to the Service Hub task master"
    testId="service-tasks"
    communicationMessages
  />
);
